
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { Controlador as Model, ControladorInterfaz } from '../../controlador';
    import { DataTableHeader } from 'vuetify';
    import { Pedido } from '@/__env/lib/Ventas/Pedidos';
    import { Envio } from '@/__env/lib/Ventas/Envios';
    import { Utiles } from '@/__env/pluggins/event-bus';

    @Component( {
        name: "Componente",
        props: {},
        components: {}
    } )
    export default class Componente extends Vue
    {
        @Prop()
        public Controlador: ControladorInterfaz;
        public get Pedido() { return this.Controlador.Pedido; }
        public get Estado() { return this.Controlador.Vista.Estado; }

        protected Eventos: Function[] = [];
        beforeDestroy()
        {
            this.Eventos.forEach( x => x() );
        }
        mounted()
        {

        }

        public CargandoMenu: boolean = false;
        public Opciones = [
            { Tipo: 'titulo', Titulo: 'Archivos' },
            {
                Tipo: 'opcion', Titulo: 'Nota de venta', Accion: async ( item: Pedido ) =>
                {

                    this.CargandoMenu = true;
                    let pdf = await Pedido.URLNotaDeVenta( [item] );
                    if ( pdf )
                    {
                        window.open( pdf );
                    } else
                    {
                        Utiles.Notificaciones.Error( `Error al generar archivo` );
                    }
                    this.CargandoMenu = false;
                }
            },

            {
                Tipo: 'opcion', Titulo: 'Presupuesto', Accion: async ( item: Pedido ) =>
                {

                    this.CargandoMenu = true;
                    let pdf = await Pedido.URLPresupuesto( [item] );
                    if ( pdf )
                    {
                        window.open( pdf );
                    } else
                    {
                        Utiles.Notificaciones.Error( `Error al generar archivo` );
                    }
                    this.CargandoMenu = false;
                }
            },
            {
                Tipo: 'opcion', Titulo: 'Etiqueta envío', Accion: async ( item: Pedido ) =>
                {
                    if ( item.Envio.Tipo.esMercadoEnvios || item.Envio.Tipo.esFlex )
                    {
                        this.CargandoMenu = true;
                        let pdf = await Envio.Etiquetas( item.Cuenta, [item.Envio.IdExterna] );
                        if ( pdf )
                        {
                            window.open( pdf );
                        } else
                        {
                            Utiles.Notificaciones.Error( `Etiquetas para ${item.Cuenta} no encontradas!` );
                        }
                        this.CargandoMenu = false;
                    } else
                    {
                        Utiles.Notificaciones.Error( `Etiquetas solo disponible para MercadoEnvios.` );

                    }

                }
            },
        ];


    }
